import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import CoreValue from "../pages/core-value/page";
import Protocol from "../pages/protocol/page";
import Equipment from "../pages/equipment/page";
import Testimonials from "../pages/testimonials/page";
import Stories from "../pages/stories/page";
import Knowledge from "../pages/knowledge/page";
import AgingTypes from "../pages/aging-types/page";
import Articles from "../pages/articles/page";
import ArticleDetail from "../pages/article-detail/page";
import Events from "../pages/events/page";
import Booking from "../pages/booking/page";
import TestimonialDetail from "../pages/testimonial-detail/page";
import StoryDetail from "../pages/story-detail/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/core-value", element: <CoreValue /> },
  { path: "/protocol", element: <Protocol /> },
  { path: "/equipment", element: <Equipment /> },
  { path: "/testimonials", element: <Testimonials /> },
  { path: "/testimonials/:id", element: <TestimonialDetail /> },
  { path: "/stories", element: <Stories /> },
  { path: "/stories/:id", element: <StoryDetail /> },
  { path: "/knowledge", element: <Knowledge /> },
  { path: "/aging-types", element: <AgingTypes /> },
  { path: "/articles", element: <Articles /> },
  { path: "/articles/:id", element: <ArticleDetail /> },
  { path: "/events", element: <Events /> },
  { path: "/booking", element: <Booking /> },
  { path: "*", element: <NotFound /> },
];

export default routes;